module.exports = __webpack_public_path__ + "media/sfx_wrong_answer.853245ad.mp3";